export const analytics = {
  title: "Analyses",
  subtitle: "Revenus et occupation de vos logements sur la période de votre choix.",
  tabs: {
    performance: "Performance",
    channels: "Canaux",
  },
  allAccommodations: "Tous les hébergements",
  compare: {
    prevPeriod: "Période précédente",
    prevYear: "Année précédente",
    titlePrevPeriod: "Comparaison : période précédente",
    titlePrevYear: "Comparaison : année précédente",
    inlinePrevPeriod: "période précédente",
    inlinePrevYear: "année précédente",
  },
  summary: {
    currentPeriod: "Période actuelle",
    paymentFilter: "Filtre de paiement",
  },
  presets: {
    today: "Aujourd'hui",
    yesterday: "Hier",
    d7: "7 jours",
    d30: "30 jours",
    m3: "3 mois",
    m6: "6 mois",
    year: "1 an",
  },
  payment: {
    all: "Tous les paiements",
    pending: "En attente",
    paid: "Payé",
    rejected: "Refusé",
    refunded: "Remboursé",
    partial: "Paiement partiel",
  },
  kpi: {
    totalRevenue: "Revenu de la période",
    arrivalRevenue: "Valeur totale des arrivées",
    revpar: "RevPAR",
    occupancyRate: "Taux d'occupation",
    adr: "ADR",
    avgStay: "Séjour moyen",
    bookingWindow: "Fenêtre de réservation",
  },
  units: {
    days: " jours",
  },
  chart: {
    thisPeriod: "Cette période",
    subtitle: "{current} · comparé à {compared} · {payment}",
  },
  channels: {
    directBookings: "Réservations directes",
    otaBookings: "Réservations OTA",
    bookingDetails: "Détails des réservations",
    byChannel: "Par canal",
    tableChannel: "Canal",
    tableRevenue: "Revenu",
    direct: "Direct",
    ota: "OTA",
    noData: "Aucune donnée pour la période sélectionnée",
  },
  a11y: {
    chartOf: "Graphique de {label}",
    directVsOta: "Graphique des réservations directes vs OTA",
  },
};